type HomeActivityPendingSlotOptions = {
  hasPageLifecycle: boolean
  pageInteractive: boolean
  activityRequestPending: boolean
  hadPendingRequestBeforeInteractive: boolean
}

export const shouldReserveHomeActivityPendingSlot = ({
  hasPageLifecycle,
  pageInteractive,
  activityRequestPending,
  hadPendingRequestBeforeInteractive,
}: HomeActivityPendingSlotOptions) => {
  if (!hasPageLifecycle) return activityRequestPending

  return (
    !pageInteractive &&
    (activityRequestPending || hadPendingRequestBeforeInteractive)
  )
}
